module.exports = __webpack_public_path__ + "img/CW.10f1477f.png";